import Individual from "./individual/Calendar";

export default { Individual };
